import { createComponent } from '@mtfe/sweet';
import { dom, eventBus, common } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';
import { COUPON_STATUS, COUPON_REMAIN_STATUS } from '../constants/index';
import PoiInfoBase from '../common/PoiInfoBase/script';

import componentUtils from '../utils/index';
const { getGiftEventName, Describe } = componentUtils;
const { isFunction } = common;

const COMPONENT_ID = 'waimai_n6i9kw81';
const SUB_COMPONENT_COUPON_ID = 'waimai_4fy1vors';

const describePoiInfoH = new Describe('PoiInfoH', COMPONENT_ID);
const describeCoupon = new Describe('Coupon', SUB_COMPONENT_COUPON_ID);

describePoiInfoH.setSubComponent(describeCoupon);
const valueStyle = style.value;
const valueBigStyle = style.valueBig;

class PoiInfoH {
    constructor(props = {}) {
        this.propsCache = props;
        this.describe = describePoiInfoH;

        this.component = this.createDom(props);
    }
    createDom(props) {
        this.propsCache = { ...this.propsCache, ...this.props };
        const { poiInfo, isShowCoupon = true } = this.propsCache;
        const { onCouponBtnClick, onPoiInfoClick } = this.propsCache;

        const { giftInfo, poi_id_str: poiIdStr } = poiInfo;

        const calculateIsShowCoupon =
            isShowCoupon &&
            giftInfo &&
            'remainStatus' in giftInfo &&
            giftInfo.remainStatus !== COUPON_REMAIN_STATUS.REMAIN_STATUS_DEFAULT;

        const data = {
            poiInfoBaseDom: PoiInfoBase(props),
            poiInfo,
            isShowCoupon: calculateIsShowCoupon,
        };
        if (giftInfo && isShowCoupon) {
            const { gift_id: giftId } = giftInfo;
            this.btnGiftId = `gift-id${giftId}${poiIdStr}`;
            this.leftRecvId = `left-id${giftId}${poiIdStr}`;
            this.buttonWrapperId = `wrapper-id${giftId}${poiIdStr}`;

            const eventName = getGiftEventName(giftId);
            eventBus.$on(eventName, (newStatus, newRemainStatus) => {
                giftInfo.status = newStatus;
                giftInfo.remainStatus = newRemainStatus;
                this.renderCoupon(newStatus, newRemainStatus);
            });
            const { buttonText, leftRecvText, wrapperClassName } = this.getCouponText(
                giftInfo.status,
                giftInfo.remainStatus,
            );
            data.buttonText = buttonText;
            data.leftRecvText = leftRecvText;
            data.wrapperClassName = wrapperClassName;
            data.btnGiftId = this.btnGiftId;
            data.leftRecvId = this.leftRecvId;
            data.buttonWrapperId = this.buttonWrapperId;

            if (giftInfo.coupon_amount >= 10000) {
                style.value = valueBigStyle;
            } else {
                style.value = valueStyle;
            }
        }

        const events = {
            onCouponBtnClick: () => {
                if (isFunction(onCouponBtnClick)) {
                    onCouponBtnClick(poiInfo, SUB_COMPONENT_COUPON_ID);
                }
                return false;
            },
            onPoiInfoClick: () => {
                if (isFunction(onPoiInfoClick)) {
                    onPoiInfoClick(poiInfo);
                }
                return false;
            },
        };
        const component = createComponent(tpl, { data, style }, events);
        return component;
    }
    getComponent() {
        return this.component;
    }
    renderCoupon(newStatus, newRemainStatus) {
        const btnSelector = `[data-gift-id=${this.btnGiftId}]`;
        const leftRecvSelector = `[data-left-id=${this.leftRecvId}]`;
        const wrapperSelector = `[id=${this.buttonWrapperId}]`;

        const btnDomList = Array.from(document.querySelectorAll(btnSelector));
        const leftRecvDomList = Array.from(document.querySelectorAll(leftRecvSelector));
        const wrapperDomList = Array.from(document.querySelectorAll(wrapperSelector));
        const { buttonText, leftRecvText, wrapperClassName } = this.getCouponText(
            newStatus,
            newRemainStatus,
        );
        if (btnDomList.length) {
            btnDomList.forEach((btnDom) => {
                btnDom.innerText = buttonText;
            });
        }
        if (leftRecvDomList.length) {
            leftRecvDomList.forEach((leftRecvDom) => {
                leftRecvDom.innerText = leftRecvText;
            });
        }
        if (wrapperDomList.length) {
            wrapperDomList.forEach((wrapperDom) => {
                // 删除原有样式类
                wrapperDom.classList.forEach((className) => {
                    wrapperDom.classList.remove(className);
                });
                wrapperDom.classList.add(wrapperClassName);
            });
        }
    }
    getCouponText(couponStatus, newRemainStatus) {
        const { poiInfo } = this.propsCache;
        let buttonText = '';
        let leftRecvText = '';
        let wrapperClassName = '';

        if (
            newRemainStatus === COUPON_REMAIN_STATUS.REMAIN_STATUS_NEW &&
            couponStatus === COUPON_STATUS.STATUS_NEW
        ) {
            buttonText = '立即抢';
            leftRecvText = `仅剩${poiInfo.validInventory}张`;
            wrapperClassName = style.wrapperNew;
        } else if (
            newRemainStatus === COUPON_REMAIN_STATUS.REMAIN_STATUS_RECEIVED &&
            couponStatus === COUPON_STATUS.STATUS_RECEIVED
        ) {
            buttonText = '去使用';
            leftRecvText = '已抢到';
            wrapperClassName = style.wrapperReceived;
        } else if (newRemainStatus === COUPON_REMAIN_STATUS.REMAIN_STATUS_NONE) {
            buttonText = '已抢光';
            leftRecvText = '';
            wrapperClassName = style.wrapperNone;
        }

        return {
            buttonText,
            leftRecvText,
            wrapperClassName,
        };
    }
}

export default PoiInfoH;
